import { t } from "i18next";

export const genreOptions = [
  { key: "hombre", text: t("trainingWizard.genre.male"), value: "hombre" },
  { key: "mujer", text: t("trainingWizard.genre.female"), value: "mujer" },
];

export const objectiveOptions = [
  {
    key: 1,
    text: t("trainingWizard.objectives.muscleGain"),
    description: t("trainingWizard.objectives.muscleGainDescription"),
    value: "hypertrophy",
  },
  {
    key: 2,
    text: t("trainingWizard.objectives.fatReduction"),
    description: t("trainingWizard.objectives.fatReductionDescription"),
    value: "definition",
  },
  {
    key: 3,
    text: t("trainingWizard.objectives.compensatoryTraining"),
    description: t("trainingWizard.objectives.compensatoryTrainingDescription"),
    value: "health",
  },
];

export const activityOptions = [
  {
    key: 1,
    text: t("trainingWizard.activities.active"),
    description: t("trainingWizard.activities.activeDescription"),
    value: "active",
  },
  {
    key: 2,
    text: t("trainingWizard.activities.sedentary"),
    description: t("trainingWizard.activities.sedentaryDescription"),
    value: "sedentary",
  },
];

export const workOptions = [
  {
    key: "sit",
    text: t("trainingWizard.work.sitting"),
    value: "sit",
  },
  {
    key: "standing",
    text: t("trainingWizard.work.standing"),
    value: "standing",
  },
  {
    key: "crouching",
    text: t("trainingWizard.work.weighted"),
    value: "crouching",
  },
];
export type TrainingWizardPlanDay = {
  plan?: string;
  position?: string;
  days?: number;
};

export type TrainingWizardPosition = {
  label: string;
  description: string;
  days?: string;
  text: string;
};

export type TrainingWizardActivity = {
  plan?: string;
  computePosition?: (value: number) => string;
  days?: Array<TrainingWizardPlanDay>;
  positions?: Record<number, TrainingWizardPosition>;
};

// training-wizard-plans.ts
export interface TrainingWizardPlan {
  table_plan?: string;
  minAge?: number;
  maxAge?: number;
  type?: "active" | "sedentary";
  goal?: "hypertrophy" | "definition" | "health";
  gender?: "hombre" | "mujer" | "all" | "none" | "unisex";
  min?: number;
  max?: number;
  plans?: any;
  getPlan?: (value: number) => string;
  [key: number]: {
    experience: string;
    description: string;
    days: string;
    text: string;
  };
}

export const trainingWizardPlans: { [key: string]: TrainingWizardPlan } = {
  HYPERTROPHY_ACTIVE_MAN_16_20: {
    table_plan: "p_estetica_hipertrofia_hombre_16_20",
    minAge: 16,
    maxAge: 20,
    type: "active",
    goal: "hypertrophy",
    gender: "hombre",
    min: 1,
    max: 14,
    getPlan(value) {
      let plan = "1S";
      if (value > 1 && value < 5) plan = String(value - 1);
      else if (value >= 5 && value < 8) plan = "4";
      else if (value >= 8 && value < 10) plan = "6";
      else if (value === 10) plan = "8";
      else if (value > 10 && value < 13) plan = "9";
      else if (value === 13) plan = "12";
      else if (value === 14) plan = "28";
      return "N" + plan;
    },
    1: {
      experience: "training-wizard.views.hypertrophy_active_man_16_20_1",
      description:
        "training-wizard.views.hypertrophy_active_man_16_20_description_1",
      days: "training-wizard.views.hypertrophy_active_man_16_20_days_1",
      text: "training-wizard.views.hypertrophy_active_man_16_20_text_1",
    },
    3: {
      experience: "training-wizard.views.hypertrophy_active_man_16_20_3",
      description:
        "training-wizard.views.hypertrophy_active_man_16_20_description_3",
      days: "training-wizard.views.hypertrophy_active_man_16_20_days_3",
      text: "training-wizard.views.hypertrophy_active_man_16_20_text_3",
    },
    5: {
      experience: "training-wizard.views.hypertrophy_active_man_16_20_5",
      description:
        "training-wizard.views.hypertrophy_active_man_16_20_description_5",
      days: "training-wizard.views.hypertrophy_active_man_16_20_days_5",
      text: "training-wizard.views.hypertrophy_active_man_16_20_text_5",
    },
    8: {
      experience: "training-wizard.views.hypertrophy_active_man_16_20_8",
      description:
        "training-wizard.views.hypertrophy_active_man_16_20_description_8",
      days: "training-wizard.views.hypertrophy_active_man_16_20_days_8",
      text: "training-wizard.views.hypertrophy_active_man_16_20_text_8",
    },
    11: {
      experience: "training-wizard.views.hypertrophy_active_man_16_20_11",
      description:
        "training-wizard.views.hypertrophy_active_man_16_20_description_11",
      days: "training-wizard.views.hypertrophy_active_man_16_20_days_11",
      text: "training-wizard.views.hypertrophy_active_man_16_20_text_11",
    },
    13: {
      experience: "training-wizard.views.hypertrophy_active_man_16_20_13",
      description:
        "training-wizard.views.hypertrophy_active_man_16_20_description_13",
      days: "training-wizard.views.hypertrophy_active_man_16_20_days_13",
      text: "training-wizard.views.hypertrophy_active_man_16_20_text_13",
    },
    14: {
      experience: "training-wizard.views.hypertrophy_active_man_16_20_14",
      description:
        "training-wizard.views.hypertrophy_active_man_16_20_description_14",
      days: "training-wizard.views.hypertrophy_active_man_16_20_days_14",
      text: "training-wizard.views.hypertrophy_active_man_16_20_text_14",
    },
  },
  HYPERTROPHY_ACTIVE_MAN_21_38: {
    table_plan: "p_estetica_hipertrofia_hombre_21_38",
    minAge: 21,
    maxAge: 38,
    type: "active",
    goal: "hypertrophy",
    gender: "hombre",
    min: 1,
    max: 26,
    getPlan(value) {
      let plan = "1S";
      if (value === 1 || value === 2) plan = "1S";
      else if (value > 2 && value < 9) plan = String(value - 2);
      else if (value >= 9 && value < 12) plan = "7";
      else if (value === 12 || value === 13) plan = "10";
      else if (value >= 14 && value < 21) plan = "13";
      else if (value >= 21 && value < 23) plan = "19";
      else if (value >= 23 && value < 26) plan = "25";
      else plan = "31";
      return "N" + plan;
    },
    1: {
      experience: "training-wizard.views.hypertrophy_active_man_21_38_1",
      description:
        "training-wizard.views.hypertrophy_active_man_21_38_description_1",
      days: "training-wizard.views.hypertrophy_active_man_21_38_days_1",
      text: "training-wizard.views.hypertrophy_active_man_21_38_text_1",
    },
    3: {
      experience: "training-wizard.views.hypertrophy_active_man_21_38_3",
      description:
        "training-wizard.views.hypertrophy_active_man_21_38_description_3",
      days: "training-wizard.views.hypertrophy_active_man_21_38_days_3",
      text: "training-wizard.views.hypertrophy_active_man_21_38_text_3",
    },
    4: {
      experience: "training-wizard.views.hypertrophy_active_man_21_38_5",
      description:
        "training-wizard.views.hypertrophy_active_man_21_38_description_5",
      days: "training-wizard.views.hypertrophy_active_man_21_38_days_5",
      text: "training-wizard.views.hypertrophy_active_man_21_38_text_5",
    },
    8: {
      experience: "training-wizard.views.hypertrophy_active_man_21_38_8",
      description:
        "training-wizard.views.hypertrophy_active_man_21_38_description_8",
      days: "training-wizard.views.hypertrophy_active_man_21_38_days_8",
      text: "training-wizard.views.hypertrophy_active_man_21_38_text_8",
    },
    11: {
      experience: "training-wizard.views.hypertrophy_active_man_21_38_11",
      description:
        "training-wizard.views.hypertrophy_active_man_21_38_description_11",
      days: "training-wizard.views.hypertrophy_active_man_21_38_days_11",
      text: "training-wizard.views.hypertrophy_active_man_21_38_text_11",
    },
    13: {
      experience: "training-wizard.views.hypertrophy_active_man_21_38_13",
      description:
        "training-wizard.views.hypertrophy_active_man_21_38_description_13",
      days: "training-wizard.views.hypertrophy_active_man_21_38_days_13",
      text: "training-wizard.views.hypertrophy_active_man_21_38_text_13",
    },
    20: {
      experience: "training-wizard.views.hypertrophy_active_man_21_38_20",
      description:
        "training-wizard.views.hypertrophy_active_man_21_38_description_20",
      days: "training-wizard.views.hypertrophy_active_man_21_38_days_20",
      text: "training-wizard.views.hypertrophy_active_man_21_38_text_20",
    },
    23: {
      experience: "training-wizard.views.hypertrophy_active_man_21_38_23",
      description:
        "training-wizard.views.hypertrophy_active_man_21_38_description_23",
      days: "training-wizard.views.hypertrophy_active_man_21_38_days_23",
      text: "training-wizard.views.hypertrophy_active_man_21_38_text_23",
    },
    25: {
      experience: "training-wizard.views.hypertrophy_active_man_21_38_25",
      description:
        "training-wizard.views.hypertrophy_active_man_21_38_description_25",
      days: "training-wizard.views.hypertrophy_active_man_21_38_days_25",
      text: "training-wizard.views.hypertrophy_active_man_21_38_text_25",
    },
  },
  HYPERTROPHY_ACTIVE_MAN_39_50: {
    table_plan: "p_estetica_hipertrofia_hombre_39_50",
    minAge: 39,
    maxAge: 100,
    type: "active",
    goal: "hypertrophy",
    gender: "hombre",
    min: 1,
    max: 10,
    getPlan(value) {
      let plan;
      if (value >= 1 && value < 4) {
        plan = "N1";
      } else if (value >= 4 && value < 8) {
        plan = "N3";
      } else {
        plan = "N5";
      }
      return plan;
    },
    1: {
      experience: "training-wizard.views.hypertrophy_active_man_39_50_1",
      description:
        "training-wizard.views.hypertrophy_active_man_39_50_description_1",
      days: "training-wizard.views.hypertrophy_active_man_39_50_days_1",
      text: "training-wizard.views.hypertrophy_active_man_39_50_text_1",
    },
    2: {
      experience: "training-wizard.views.hypertrophy_active_man_39_50_2",
      description:
        "training-wizard.views.hypertrophy_active_man_39_50_description_2",
      days: "training-wizard.views.hypertrophy_active_man_39_50_days_2",
      text: "training-wizard.views.hypertrophy_active_man_39_50_text_2",
    },
    4: {
      experience: "training-wizard.views.hypertrophy_active_man_39_50_4",
      description:
        "training-wizard.views.hypertrophy_active_man_39_50_description_4",
      days: "training-wizard.views.hypertrophy_active_man_39_50_days_4",
      text: "training-wizard.views.hypertrophy_active_man_39_50_text_4",
    },
    6: {
      experience: "training-wizard.views.hypertrophy_active_man_39_50_6",
      description:
        "training-wizard.views.hypertrophy_active_man_39_50_description_6",
      days: "training-wizard.views.hypertrophy_active_man_39_50_days_6",
      text: "training-wizard.views.hypertrophy_active_man_39_50_text_6",
    },
    8: {
      experience: "training-wizard.views.hypertrophy_active_man_39_50_8",
      description:
        "training-wizard.views.hypertrophy_active_man_39_50_description_8",
      days: "training-wizard.views.hypertrophy_active_man_39_50_days_8",
      text: "training-wizard.views.hypertrophy_active_man_39_50_text_8",
    },
    9: {
      experience: "training-wizard.views.hypertrophy_active_man_39_50_9",
      description:
        "training-wizard.views.hypertrophy_active_man_39_50_description_9",
      days: "training-wizard.views.hypertrophy_active_man_39_50_days_9",
      text: "training-wizard.views.hypertrophy_active_man_39_50_text_9",
    },
  },
  HYPERTROPHY_ACTIVE_WOMAN_16_48: {
    table_plan: "p_estetica_hipertrofia_mujer_16_48",
    minAge: 16,
    maxAge: 100,
    type: "active",
    goal: "hypertrophy",
    gender: "mujer",
    min: 1,
    max: 19,
    getPlan(value) {
      let plan = "1";
      if (value >= 1 && value < 4) plan = String(value);
      else if (value >= 4 && value < 7) plan = "4";
      else if (value >= 7 && value < 9) plan = "7";
      else if (value >= 9 && value < 13) plan = "9";
      else if (value >= 13 && value < 16) plan = "14.1";
      else if (value === 16 || value === 17) plan = "18.1";
      else if (value === 18 || value === 19) plan = "21.1";
      return "N" + plan;
    },
    1: {
      experience: "training-wizard.views.hypertrophy_active_woman_16_48_1",
      description:
        "training-wizard.views.hypertrophy_active_woman_16_48_description_1",
      days: "training-wizard.views.hypertrophy_active_woman_16_48_days_1",
      text: "training-wizard.views.hypertrophy_active_woman_16_48_text_1",
    },
    2: {
      experience: "training-wizard.views.hypertrophy_active_woman_16_48_2",
      description:
        "training-wizard.views.hypertrophy_active_woman_16_48_description_2",
      days: "training-wizard.views.hypertrophy_active_woman_16_48_days_2",
      text: "training-wizard.views.hypertrophy_active_woman_16_48_text_2",
    },
    4: {
      experience: "training-wizard.views.hypertrophy_active_woman_16_48_4",
      description:
        "training-wizard.views.hypertrophy_active_woman_16_48_description_4",
      days: "training-wizard.views.hypertrophy_active_woman_16_48_days_4",
      text: "training-wizard.views.hypertrophy_active_woman_16_48_text_4",
    },
    7: {
      experience: "training-wizard.views.hypertrophy_active_woman_16_48_7",
      description:
        "training-wizard.views.hypertrophy_active_woman_16_48_description_7",
      days: "training-wizard.views.hypertrophy_active_woman_16_48_days_7",
      text: "training-wizard.views.hypertrophy_active_woman_16_48_text_7",
    },
    9: {
      experience: "training-wizard.views.hypertrophy_active_woman_16_48_9",
      description:
        "training-wizard.views.hypertrophy_active_woman_16_48_description_9",
      days: "training-wizard.views.hypertrophy_active_woman_16_48_days_9",
      text: "training-wizard.views.hypertrophy_active_woman_16_48_text_9",
    },
    13: {
      experience: "training-wizard.views.hypertrophy_active_woman_16_48_13",
      description:
        "training-wizard.views.hypertrophy_active_woman_16_48_description_13",
      days: "training-wizard.views.hypertrophy_active_woman_16_48_days_13",
      text: "training-wizard.views.hypertrophy_active_woman_16_48_text_13",
    },
    16: {
      experience: "training-wizard.views.hypertrophy_active_woman_16_48_16",
      description:
        "training-wizard.views.hypertrophy_active_woman_16_48_description_16",
      days: "training-wizard.views.hypertrophy_active_woman_16_48_days_16",
      text: "training-wizard.views.hypertrophy_active_woman_16_48_text_16",
    },
    18: {
      experience: "training-wizard.views.hypertrophy_active_woman_16_48_18",
      description:
        "training-wizard.views.hypertrophy_active_woman_16_48_description_18",
      days: "training-wizard.views.hypertrophy_active_woman_16_48_days_18",
      text: "training-wizard.views.hypertrophy_active_woman_16_48_text_18",
    },
  },
  DEFINITION_ACTIVE_MAN_16_20: {
    table_plan: "p_estetica_definicion_hombre_16_20_activo",
    minAge: 16,
    maxAge: 20,
    type: "active",
    goal: "definition",
    gender: "hombre",
    min: 1,
    max: 8,
    getPlan(value) {
      let plan = "N1";
      if (value >= 1 && value < 5) plan = "N1";
      else if (value >= 5 && value < 8) plan = "N5";
      else plan = "N8";
      return plan;
    },
    1: {
      experience: "training-wizard.views.definition_active_man_16_20_1",
      description:
        "training-wizard.views.definition_active_man_16_20_description_1",
      days: "training-wizard.views.definition_active_man_16_20_days_1",
      text: "training-wizard.views.definition_active_man_16_20_text_1",
    },
    5: {
      experience: "training-wizard.views.definition_active_man_16_20_5",
      description:
        "training-wizard.views.definition_active_man_16_20_description_5",
      days: "training-wizard.views.definition_active_man_16_20_days_5",
      text: "training-wizard.views.definition_active_man_16_20_text_5",
    },
    8: {
      experience: "training-wizard.views.definition_active_man_16_20_8",
      description:
        "training-wizard.views.definition_active_man_16_20_description_8",
      days: "training-wizard.views.definition_active_man_16_20_days_8",
      text: "training-wizard.views.definition_active_man_16_20_text_8",
    },
  },
  DEFINITION_ACTIVE_MAN_21_38: {
    table_plan: "p_estetica_definicion_hombre_21_38_activo",
    minAge: 21,
    maxAge: 38,
    type: "active",
    goal: "definition",
    gender: "hombre",
    min: 1,
    max: 12,
    getPlan(value) {
      let plan = "N1";
      if (value >= 1 && value < 5) plan = "N1";
      else if (value >= 5 && value < 8) plan = "N5";
      else if (value >= 8 && value < 11) plan = "N8_E";
      else plan = "N8";
      return plan;
    },
    1: {
      experience: "training-wizard.views.definition_active_man_21_38_1",
      description:
        "training-wizard.views.definition_active_man_21_38_description_1",
      days: "training-wizard.views.definition_active_man_21_38_days_1",
      text: "training-wizard.views.definition_active_man_21_38_text_1",
    },
    5: {
      experience: "training-wizard.views.definition_active_man_21_38_5",
      description:
        "training-wizard.views.definition_active_man_21_38_description_5",
      days: "training-wizard.views.definition_active_man_21_38_days_5",
      text: "training-wizard.views.definition_active_man_21_38_text_5",
    },
    8: {
      experience: "training-wizard.views.definition_active_man_21_38_8",
      description:
        "training-wizard.views.definition_active_man_21_38_description_8",
      days: "training-wizard.views.definition_active_man_21_38_days_8",
      text: "training-wizard.views.definition_active_man_21_38_text_8",
    },
    11: {
      experience: "training-wizard.views.definition_active_man_21_38_11",
      description:
        "training-wizard.views.definition_active_man_21_38_description_11",
      days: "training-wizard.views.definition_active_man_21_38_days_11",
      text: "training-wizard.views.definition_active_man_21_38_text_11",
    },
  },
  DEFINITION_ACTIVE_MAN_39_50: {
    table_plan: "p_estetica_definicion_hombre_39_50_activo",
    minAge: 39,
    maxAge: 100,
    type: "active",
    goal: "definition",
    gender: "hombre",
    min: 1,
    max: 9,
    getPlan(value) {
      let plan = "N1";
      if (value >= 1 && value < 4) plan = "N1";
      else if (value >= 4 && value < 8) plan = "N3";
      else plan = "N5";
      return plan;
    },
    1: {
      experience: "training-wizard.views.definition_active_man_39_50_1",
      description:
        "training-wizard.views.definition_active_man_39_50_description_1",
      days: "training-wizard.views.definition_active_man_39_50_days_1",
      text: "training-wizard.views.definition_active_man_39_50_text_1",
    },
    4: {
      experience: "training-wizard.views.definition_active_man_39_50_4",
      description:
        "training-wizard.views.definition_active_man_39_50_description_4",
      days: "training-wizard.views.definition_active_man_39_50_days_4",
      text: "training-wizard.views.definition_active_man_39_50_text_4",
    },
    8: {
      experience: "training-wizard.views.definition_active_man_39_50_8",
      description:
        "training-wizard.views.definition_active_man_39_50_description_8",
      days: "training-wizard.views.definition_active_man_39_50_days_8",
      text: "training-wizard.views.definition_active_man_39_50_text_8",
    },
  },
  DEFINITION_ACTIVE_WOMAN_16_48: {
    table_plan: "p_estetica_definicion_mujer_16_48_activo",
    minAge: 16,
    maxAge: 100,
    type: "active",
    goal: "definition",
    gender: "mujer",
    min: 1,
    max: 8,
    getPlan(value) {
      let plan = "N1S";
      if (value >= 1 && value < 4) plan = "N1";
      else if (value >= 4 && value < 7) plan = "N4";
      else plan = "N7";
      return plan;
    },
    1: {
      experience: "training-wizard.views.definition_active_woman_16_48_1",
      description:
        "training-wizard.views.definition_active_woman_16_48_description_1",
      days: "training-wizard.views.definition_active_woman_16_48_days_1",
      text: "training-wizard.views.definition_active_woman_16_48_text_1",
    },
    4: {
      experience: "training-wizard.views.definition_active_woman_16_48_4",
      description:
        "training-wizard.views.definition_active_woman_16_48_description_4",
      days: "training-wizard.views.definition_active_woman_16_48_days_4",
      text: "training-wizard.views.definition_active_woman_16_48_text_4",
    },
    7: {
      experience: "training-wizard.views.definition_active_woman_16_48_7",
      description:
        "training-wizard.views.definition_active_woman_16_48_description_7",
      days: "training-wizard.views.definition_active_woman_16_48_days_7",
      text: "training-wizard.views.definition_active_woman_16_48_text_7",
    },
  },
  /*   SALUD_SIT_ACTIVE: {
    table_plan: "p_salud_gimnasio_sentado_activo",
    minAge: 0,
    maxAge: 100,
    type: "active",
    goal: "health",
    gender: "all",
    min: 1,
    max: 5,
    getPlan(value) {
      return "N" + value;
    },
    1: {
      experience: "training-wizard.views.salud_active_1",
      description: "training-wizard.views.salud_active_description_1",
      days: "training-wizard.views.salud_active_days_1",
      text: "training-wizard.views.salud_active_text_1",
    },
    2: {
      experience: "training-wizard.views.salud_active_2",
      description: "training-wizard.views.salud_active_description_2",
      days: "training-wizard.views.salud_active_days_2",
      text: "training-wizard.views.salud_active_text_2",
    },
    3: {
      experience: "training-wizard.views.salud_active_3",
      description: "training-wizard.views.salud_active_description_3",
      days: "training-wizard.views.salud_active_days_3",
      text: "training-wizard.views.salud_active_text_3",
    },
    4: {
      experience: "training-wizard.views.salud_active_4",
      description: "training-wizard.views.salud_active_description_4",
      days: "training-wizard.views.salud_active_days_4",
      text: "training-wizard.views.salud_active_text_4",
    },
    5: {
      experience: "training-wizard.views.salud_active_5",
      description: "training-wizard.views.salud_active_description_5",
      days: "training-wizard.views.salud_active_days_5",
      text: "training-wizard.views.salud_active_text_5",
    },
  }, */

  /* SALUD_STANDING_ACTIVE: {
    table_plan: "p_salud_gimnasio_pie_activo",
    minAge: 0,
    maxAge: 100,
    type: "active",
    goal: "health",
    gender: "all",
    min: 1,
    max: 5,
    getPlan(value) {
      return "N" + value;
    },
    1: {
      experience: "training-wizard.views.salud_active_1",
      description: "training-wizard.views.salud_active_description_1",
      days: "training-wizard.views.salud_active_days_1",
      text: "training-wizard.views.salud_active_text_1",
    },
    2: {
      experience: "training-wizard.views.salud_active_2",
      description: "training-wizard.views.salud_active_description_2",
      days: "training-wizard.views.salud_active_days_2",
      text: "training-wizard.views.salud_active_text_2",
    },
    3: {
      experience: "training-wizard.views.salud_active_3",
      description: "training-wizard.views.salud_active_description_3",
      days: "training-wizard.views.salud_active_days_3",
      text: "training-wizard.views.salud_active_text_3",
    },
    4: {
      experience: "training-wizard.views.salud_active_4",
      description: "training-wizard.views.salud_active_description_4",
      days: "training-wizard.views.salud_active_days_4",
      text: "training-wizard.views.salud_active_text_4",
    },
    5: {
      experience: "training-wizard.views.salud_active_5",
      description: "training-wizard.views.salud_active_description_5",
      days: "training-wizard.views.salud_active_days_5",
      text: "training-wizard.views.salud_active_text_5",
    },
  }, */

  //sedentary

  DEFINITION_SEDENTARY_MAN_16_20: {
    minAge: 16,
    maxAge: 20,
    type: "sedentary",
    goal: "definition",
    gender: "hombre",
    plans: {
      days: [
        {
          plan: "p_estetica_definicion_hombre_16_20_sedentario_continuo",
          position: "N1",
          days: 3,
        },
        {
          plan: "p_estetica_definicion_hombre_16_20_sedentario_continuo",
          position: "N1",
          days: 4,
        },
      ],
    },
  },
  DEFINITION_SEDENTARY_MAN_21_38: {
    minAge: 21,
    maxAge: 38,
    type: "sedentary",
    goal: "definition",
    gender: "hombre",
    plans: {
      days: [
        {
          plan: "p_estetica_definicion_hombre_21_38_sedentario_continuo",
          position: "N1",
          days: 3,
        },
        {
          plan: "p_estetica_definicion_hombre_21_38_sedentario_natural_4",
          position: "N1",
          days: 4,
        },
        {
          plan: "p_estetica_definicion_hombre_21_38_sedentario_natural_5",
          position: "N1",
          days: 5,
        },
      ],
    },
  },
  DEFINITION_SEDENTARY_MAN_39_50: {
    minAge: 39,
    maxAge: 99,
    type: "sedentary",
    goal: "definition",
    gender: "hombre",
    plans: {
      days: [
        {
          plan: "p_estetica_definicion_hombre_39_50_sedentario",
          position: "N1",
          days: 3,
        },
        {
          plan: "p_estetica_definicion_hombre_39_50_sedentario",
          position: "N7",
          days: 4,
        },
      ],
    },
  },
  DEFINITION_SEDENTARY_WOMAN_16_48: {
    minAge: 16,
    maxAge: 99,
    type: "sedentary",
    goal: "definition",
    gender: "mujer",
    plans: {
      days: [
        {
          plan: "p_estetica_definicion_mujer_16_48_sedentario_continuo",
          position: "N1",
          days: 3,
        },
        {
          plan: "p_estetica_definicion_mujer_16_48_sedentario_natural_4",
          position: "N7",
          days: 4,
        },
      ],
    },
  },
  HYPERTROPHY_SEDENTARY_MAN_16_20: {
    minAge: 16,
    maxAge: 20,
    type: "sedentary",
    goal: "hypertrophy",
    gender: "hombre",
    plans: {
      days: [
        {
          plan: "p_estetica_definicion_hombre_16_20_sedentario_continuo",
          position: "N1",
          days: 3,
        },
        {
          plan: "p_estetica_definicion_hombre_16_20_sedentario_continuo",
          position: "N1",
          days: 4,
        },
      ],
    },
  },
  HYPERTROPHY_SEDENTARY_MAN_21_38: {
    minAge: 21,
    maxAge: 38,
    type: "sedentary",
    goal: "hypertrophy",
    gender: "hombre",
    plans: {
      days: [
        {
          plan: "p_estetica_definicion_hombre_16_20_sedentario_continuo",
          position: "N1",
          days: 3,
        },
        {
          plan: "p_estetica_definicion_hombre_16_20_sedentario_continuo",
          position: "N1",
          days: 4,
        },
      ],
    },
  },
  HYPERTROPHY_SEDENTARY_MAN_39_50: {
    minAge: 39,
    maxAge: 99,
    type: "sedentary",
    goal: "hypertrophy",
    gender: "hombre",
    plans: {
      days: [
        {
          plan: "p_estetica_definicion_hombre_16_20_sedentario_continuo",
          position: "N1",
          days: 3,
        },
        {
          plan: "p_estetica_definicion_hombre_16_20_sedentario_continuo",
          position: "N1",
          days: 4,
        },
      ],
    },
  },
  HYPERTROPHY_SEDENTARY_WOMAN_16_48: {
    minAge: 16,
    maxAge: 99,
    type: "sedentary",
    goal: "hypertrophy",
    gender: "mujer",
    plans: {
      days: [
        {
          plan: "p_estetica_hipertrofia_mujer_16_48",
          position: "N1",
          days: 3,
        }, // Añadí days: 3 como valor por defecto
      ],
    },
  },
  HEALTH_SEDENTARY_GYM_CROUCHING: {
    minAge: 0,
    maxAge: 99,
    type: "sedentary",
    goal: "health",
    gender: "unisex",
    plans: {
      days: [], // No hay opciones definidas en la versión anterior
    },
  },
  HEALTH_SEDENTARY_GYM_STANDING: {
    minAge: 0,
    maxAge: 99,
    type: "sedentary",
    goal: "health",
    gender: "unisex",
    plans: {
      days: [
        {
          plan: "p_salud_gimnasio_pie_sedentario_2",
          position: "N1",
          days: 2,
        },
        {
          plan: "p_salud_gimnasio_pie_sedentario_3",
          position: "N1",
          days: 3,
        },
        {
          plan: "p_salud_gimnasio_pie_sedentario_4",
          position: "N1",
          days: 4,
        }, // Corregí el espacio en "N1         "
      ],
    },
  },
  HEALTH_SEDENTARY_GYM_SITTING: {
    minAge: 0,
    maxAge: 99,
    type: "sedentary",
    goal: "health",
    gender: "unisex",
    plans: {
      days: [
        {
          plan: "p_salud_gimnasio_sentado_sedentario_2",
          position: "N1_3",
          days: 2,
        },
        {
          plan: "p_salud_gimnasio_sentado_sedentario_3",
          position: "N1_3",
          days: 3,
        },
        {
          plan: "p_salud_gimnasio_sentado_sedentario_4",
          position: "N1",
          days: 4,
        }, // Corregí el espacio en "N1         "
      ],
    },
  },

  SALUD_SIT_SEDENTARY: {
    minAge: 0,
    maxAge: 99,
    type: "sedentary",
    goal: "health",
    gender: "unisex",
    plans: {
      days: [
        {
          plan: "p_salud_gimnasio_sentado_sedentario_2",
          position: "N1_3",
          days: 2,
        },
        {
          plan: "p_salud_gimnasio_sentado_sedentario_3",
          position: "N1_3",
          days: 3,
        },
        {
          plan: "p_salud_gimnasio_sentado_sedentario_4",
          position: "N1         ",
          days: 4,
        },
      ],
    },
  },

  SALUD_STANDING_SEDENTARY: {
    minAge: 0,
    maxAge: 99,
    type: "sedentary",
    goal: "health",
    gender: "unisex",
    plans: {
      days: [
        {
          plan: "p_salud_gimnasio_pie_sedentario_2",
          position: "N1",
          days: 2,
        },
        {
          plan: "p_salud_gimnasio_pie_sedentario_3",
          position: "N1",
          days: 3,
        },
        {
          plan: "p_salud_gimnasio_pie_sedentario_4",
          position: "N1         ",
          days: 4,
        },
      ],
    },
  },

  SALUD_DOWN_SEDENTARY: {
    minAge: 0,
    maxAge: 99,
    type: "sedentary",
    goal: "health",
    gender: "unisex",
    plans: {
      days: [
        {
          plan: "p_salud_gimnasio_sentado_sedentario_2",
          position: "N1_3",
          days: 2,
        },
        {
          plan: "p_salud_gimnasio_sentado_sedentario_3",
          position: "N1_3",
          days: 3,
        },
        {
          plan: "p_salud_gimnasio_sentado_sedentario_4",
          position: "N1         ",
          days: 4,
        },
      ],
    },
  },

  //brake
  SALUD_DOWN_ACTIVE: {
    minAge: 0,
    maxAge: 100,
    type: "active",
    goal: "health",
    gender: "all",
    min: 1,
    max: 5,
    getPlan: (experience: number) => {
      if (experience <= 2) return "N1";
      if (experience <= 4) return "N2";
      return "N3";
    },
    1: {
      experience: "training-wizard.views.salud_active_1",
      description: "training-wizard.views.salud_active_description_1",
      days: "training-wizard.views.salud_active_days_1",
      text: "training-wizard.views.salud_active_text_1",
    },
    2: {
      experience: "training-wizard.views.salud_active_2",
      description: "training-wizard.views.salud_active_description_2",
      days: "training-wizard.views.salud_active_days_2",
      text: "training-wizard.views.salud_active_text_2",
    },
    3: {
      experience: "training-wizard.views.salud_active_3",
      description: "training-wizard.views.salud_active_description_3",
      days: "training-wizard.views.salud_active_days_3",
      text: "training-wizard.views.salud_active_text_3",
    },
    4: {
      experience: "training-wizard.views.salud_active_4",
      description: "training-wizard.views.salud_active_description_4",
      days: "training-wizard.views.salud_active_days_4",
      text: "training-wizard.views.salud_active_text_4",
    },
    5: {
      experience: "training-wizard.views.salud_active_5",
      description: "training-wizard.views.salud_active_description_4",
      days: "training-wizard.views.salud_active_days_4",
      text: "training-wizard.views.salud_active_text_4",
    },
    table_plan: "p_salud_gimnasio_agachado_activo",
    plans: {
      days: [
        {
          plan: "p_salud_gimnasio_agachado_activo_2",
          position: "N1",
          days: 2,
        },
        {
          plan: "p_salud_gimnasio_agachado_activo_3",
          position: "N2",
          days: 3,
        },
        {
          plan: "p_salud_gimnasio_agachado_activo_4",
          position: "N3",
          days: 4,
        },
      ],
    },
  },
  //@ts-ignore
  SALUD_SIT_ACTIVE: {
    minAge: 0,
    maxAge: 100,
    type: "active",
    goal: "health",
    gender: "all",
    min: 1,
    max: 5,
    getPlan: (value) => `N${value}`,
    1: {
      experience: "training-wizard.views.salud_active_1",
      description: "training-wizard.views.salud_active_description_1",
      days: "training-wizard.views.salud_active_days_1",
      text: "training-wizard.views.salud_active_text_1",
    },
    2: {
      experience: "training-wizard.views.salud_active_2",
      description: "training-wizard.views.salud_active_description_2",
      days: "training-wizard.views.salud_active_days_2",
      text: "training-wizard.views.salud_active_text_2",
    },
    3: {
      experience: "training-wizard.views.salud_active_3",
      description: "training-wizard.views.salud_active_description_3",
      days: "training-wizard.views.salud_active_days_3",
      text: "training-wizard.views.salud_active_text_3",
    },
    4: {
      experience: "training-wizard.views.salud_active_4",
      description: "training-wizard.views.salud_active_description_4",
      days: "training-wizard.views.salud_active_days_4",
      text: "training-wizard.views.salud_active_text_4",
    },
    5: {
      experience: "training-wizard.views.salud_active_5",
      description: "training-wizard.views.salud_active_description_4",
      days: "training-wizard.views.salud_active_days_4",
      text: "training-wizard.views.salud_active_text_4",
    },
    table_plan: "p_salud_gimnasio_sentado_activo",
    plans: {
      days: [
        {
          plan: "p_salud_gimnasio_sentado_activo_2",
          days: 2,
        },
        {
          plan: "p_salud_gimnasio_sentado_activo_3",
          days: 3,
        },
        {
          plan: "p_salud_gimnasio_sentado_activo_4",
          days: 4,
        },
      ],
    },
  },

  /* @ts-ignore */
  SALUD_STANDING_ACTIVE: {
    minAge: 0,
    maxAge: 100,
    type: "active",
    goal: "health",
    gender: "all",
    min: 1,
    max: 5,
    getPlan: (value) => `N${value}`,
    1: {
      experience: "training-wizard.views.salud_active_1",
      description: "training-wizard.views.salud_active_description_1",
      days: "training-wizard.views.salud_active_days_1",
      text: "training-wizard.views.salud_active_text_1",
    },
    2: {
      experience: "training-wizard.views.salud_active_2",
      description: "training-wizard.views.salud_active_description_2",
      days: "training-wizard.views.salud_active_days_2",
      text: "training-wizard.views.salud_active_text_2",
    },
    3: {
      experience: "training-wizard.views.salud_active_3",
      description: "training-wizard.views.salud_active_description_3",
      days: "training-wizard.views.salud_active_days_3",
      text: "training-wizard.views.salud_active_text_3",
    },
    4: {
      experience: "training-wizard.views.salud_active_4",
      description: "training-wizard.views.salud_active_description_4",
      days: "training-wizard.views.salud_active_days_4",
      text: "training-wizard.views.salud_active_text_4",
    },
    5: {
      experience: "training-wizard.views.salud_active_5",
      description: "training-wizard.views.salud_active_description_4",
      days: "training-wizard.views.salud_active_days_4",
      text: "training-wizard.views.salud_active_text_4",
    },

    plans: {
      days: [
        {
          plan: "p_salud_gimnasio_pie_sedentario_2",
          position: "N1",
          days: 2,
        },
        {
          plan: "p_salud_gimnasio_pie_sedentario_3",
          position: "N1",
          days: 3,
        },
        {
          plan: "p_salud_gimnasio_pie_sedentario_4",
          position: "N1",
          days: 4,
        },
      ],
    },
  },
};

export const sicleOption = [
  {
    key: 1,
    text: "Si",
    value: "si",
  },
  {
    key: 2,
    text: "No",
    value: "no",
  },
];
